import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7eba7ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statistic" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "statistic__title" }, "Статистика клиники", -1))

import { PropType } from 'vue'
import { StatisticAppointmentType, StatisticReportType } from '@/shared/types'
import IndicatorsStatisticChart from '@/widgets/WIndicatorsStatistic/components/IndicatorsStatisticChart.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  reports: Array as PropType<
    StatisticReportType[] | StatisticAppointmentType[]
  >,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(), _createBlock(IndicatorsStatisticChart, {
      key: __props.reports,
      reports: __props.reports
    }, null, 8, ["reports"]))
  ]))
}
}

})